import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {StoreStatisticsService} from "../../services/statistics-services/store-statistics.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MultiDateSeries} from "../../../shared/view-model/core/multi-date-series.type";
import * as d3 from 'd3-shape';
import {DatePipe} from "@angular/common";
import {map} from "rxjs/operators";
import {FileService} from '../../../core/visbos-core/http/file.service';

@Component({
  selector: 'vb-consumption-statistics-view',
  templateUrl: './consumption-statistics-view.component.html',
  styleUrls: ['./consumption-statistics-view.component.css']
})
export class ConsumptionStatisticsViewComponent extends AbstractVisbosComponent implements OnInit {

  consumptionByConsumerData: any[] = [];
  consumptionByConsumerByTimeData: MultiDateSeries[] = [];

  consumptionByTypeData: any[] = [];
  consumptionByTypeByTimeData: MultiDateSeries[] = [];

  filterControl: FormGroup;

  view: any[] = [553, 300];

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  label = "Insgesamt";
  legendTitle = "Legende";
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Zeit';
  showYAxisLabel = true;
  yAxisLabel = '%';

  xAxisTickFormatting = (label) => {
    return this.datePipe.transform(label, 'short');
  };

  curve = d3.curveStep;

  colorScheme = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  };

  // line, area
  autoScale = true;


  constructor(sessionActions: SessionActions, private fb: FormBuilder,
              private statisticsService: StoreStatisticsService, cd: ChangeDetectorRef,
              private datePipe: DatePipe, private fileService: FileService) {
    super(sessionActions, cd);

    this.actions = [{
      label: 'Kostenstellen-Report exportieren',
      icon: 'fa-download',
      action: () => this.onExportAccountStatistics.apply(this)
    }];

  }

  ngOnInit() {

    this.filterControl = this.fb.group({
      depot_cuid: [null],
      start_date: [null],
      end_date: [null]
    });

    let depotCuid$ = this.filterControl.valueChanges.pipe(map(form => form.depot_cuid));
    let startDate$ = this.filterControl.valueChanges.pipe(map(form => form.start_date));
    let endDate$ = this.filterControl.valueChanges.pipe(map(form => form.end_date));

    let data1$ = this.statisticsService.getConsumptionByConsumerStatistics(null, depotCuid$, startDate$, endDate$);
    this.addComponentData(data1$);

    this.dataSubscriptions.push(data1$.subscribe(res => {
      this.isLoading = res.loading;
      this.consumptionByConsumerData = res.data.consumptionByConsumerStatistics;
      this.cd.detectChanges();
    }));

    let data2$ = this.statisticsService.getConsumptionByTypeStatistics(null, depotCuid$, startDate$, endDate$);
    this.addComponentData(data2$);

    this.dataSubscriptions.push(data2$.subscribe(res => {
      this.isLoading = res.loading;
      this.consumptionByTypeData = res.data.consumptionByTypeStatistics;
      this.cd.detectChanges();
    }));


    let data3$ = this.statisticsService.getConsumptionByConsumerByTimeStatistics('Y-W', null, depotCuid$, startDate$, endDate$);
    this.addComponentData(data3$);

    this.dataSubscriptions.push(data3$.subscribe(res => {
      this.isLoading = res.loading;
      this.consumptionByConsumerByTimeData = this.statisticsService.transformMultiSeriesToDateSeries(res.data.consumptionByConsumerByTimeStatistics);
      this.cd.detectChanges();
    }));

    let data4$ = this.statisticsService.getConsumptionByTypeByTimeStatistics('Y-W', null, depotCuid$, startDate$, endDate$);
    this.addComponentData(data4$);

    this.dataSubscriptions.push(data4$.subscribe(res => {
      this.isLoading = res.loading;
      this.consumptionByTypeByTimeData = this.statisticsService.transformMultiSeriesToDateSeries(res.data.consumptionByTypeByTimeStatistics);
      this.cd.detectChanges();
    }));

  }

  onSelect(event) {
    console.log(event);
  }

  onExportAccountStatistics() {
    this.statisticsService.generateAccountStatisticsExport(this.activeAdminUnitCuid).subscribe(response => {
      this.fileService.saveResponseToFileSystem(response);
    }, err => {
      this.sessionActions.throwError(err, "Fehler beim Erzeugen der Datei!");
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/statistics/consumption-statistics-view/consumption-statistics-view.component.ts